<template>
  <div @click="copyLink" :class="['share-atom', { 'light-theme': lightTheme }]">
    <div>
      <img :src="iconSrc" />
    </div>
    <span class="share-atom__description">{{ shareText }}</span>
    <!-- Dynamic text based on language -->
    <div v-if="checkMark" class="checkmark">
      <i class="material-icons share-atom__done">done</i>
      <span>{{ copiedText }}</span>
      <!-- Dynamic text based on language -->
    </div>
  </div>
</template>

<script>
import { inject, computed } from 'vue';
export default {
  props: {
    lightTheme: {
      type: Boolean,
    },
  },
  setup() {
    const language = inject('language'); // Injecting the language context

    const isEnglish = computed(() => language.value === 'en'); // Checking if the current language is English

    const shareText = computed(() => (isEnglish.value ? 'Share' : 'Dela')); // Setting text based on language
    const copiedText = computed(() => (isEnglish.value ? 'Link copied' : 'Länk kopierad')); // Setting text for "Link copied"

    return {
      shareText,
      copiedText,
      isEnglish,
    };
  },
  data() {
    return {
      checkMark: false,
    };
  },
  computed: {
    hasNativeShare() {
      return navigator.share;
    },
    iconSrc() {
      return this.lightTheme ? require('@/assets/logotypes/share_icon_black.svg') : require('@/assets/logotypes/share_icon_white.svg');
    },
  },
  methods: {
    copyLink() {
      if (this.hasNativeShare) {
        console.log('here');
        navigator.share({
          title: 'BU-Listan',
          text: 'Titta vad jag hittade på BU-listan!',
          url: window.location.href,
        });
      } else {
        navigator.clipboard.writeText(window.location.href);
        console.log('else');
        this.checkMark = true;
        setTimeout(() => {
          this.checkMark = false;
        }, 3000);
      }
    },
  },
};
</script>

<style scoped>
img {
  width: 20px;
  margin-bottom: 1px;
}
.share-atom {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: max-content;
  margin-top: 50px;
}
.share-atom__description {
  font-family: 'fet';
  font-size: 20px;
  color: white;
  margin: 6px 0 0 10px;
}
.share-atom__share {
  color: white;
}
.light-theme .share-atom__share,
.light-theme .share-atom__description {
  color: black;
}
.share-atom:active {
  opacity: 0.5;
}
.share-atom__done {
  color: green;
  margin-left: 5px;
}
.checkmark {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 8px;
}
.checkmark span {
  color: white;
}
.light-theme .checkmark span {
  color: black;
}
</style>
